module.exports = __webpack_public_path__ + "static/media/backgroundDifuminado.f1ef04b4.jpg";